import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  const mode = ref(localStorage.getItem('theme_mode') || 'dark')
  const primaryColor = '#8C47F6'
  const systemTheme = ref('light')

  function detectSystemTheme() {
    try {
      if (typeof window !== 'undefined' && window.matchMedia) {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        systemTheme.value = isDark ? 'dark' : 'light'
        return systemTheme.value
      }
    } catch (e) {
      console.warn('[Theme] Failed to detect system theme', e)
    }
    systemTheme.value = 'dark'
    return 'dark'
  }

  const actualMode = computed(() => {
    if (mode.value === 'auto') return systemTheme.value
    return mode.value
  })

  const isDark = computed(() => actualMode.value === 'dark')

  function setTheme(newMode) {
    if (!['auto', 'light', 'dark'].includes(newMode)) return
    mode.value = newMode
    localStorage.setItem('theme_mode', newMode)
    applyTheme()
  }

  function initTheme() {
    detectSystemTheme()
    const saved = localStorage.getItem('theme_mode')
    if (saved && ['auto', 'light', 'dark'].includes(saved)) mode.value = saved
    applyTheme()
  }

  function applyTheme() {
    if (mode.value === 'auto') detectSystemTheme()
    const current = actualMode.value
    const root = document.documentElement
    if (root) {
      root.classList.remove('dark-theme', 'light-theme')
      root.classList.add(current === 'dark' ? 'dark-theme' : 'light-theme')
    }
  }

  function getThemeClass() {
    return {
      'dark-theme': isDark.value,
      'light-theme': !isDark.value
    }
  }

  return {
    mode,
    actualMode,
    isDark,
    primaryColor,
    setTheme,
    initTheme,
    applyTheme,
    getThemeClass
  }
})
